export default __webpack_public_path__ + "img/3e228a5bc1ffc34447f3b06a151d6e52.png";